export function set_attachment(attachment_data) {
    return {
        type: "@retailers_attachments/SETATTACHMENT",
        payload: attachment_data
    };
}
